import React, { FormEvent, FormEventHandler, RefObject } from "react";

/**
 * Example: <input onKeyUp={onKey({enter: doEnter})}/>
 * @param handlers
 */

export function onKey(
  handlers: Record<string, (e?: React.KeyboardEvent) => void>
): React.KeyboardEventHandler {
  return (e: React.KeyboardEvent) => {
    Object.entries(handlers).forEach(([key, handler]) => {
      [e.key.toLowerCase(), e.code.toLowerCase()].indexOf(key.toLowerCase()) >
        -1 && handler(e);
    });
  };
}

/**
 * Example: <input ref={inputRef} onKeyUp={onKey({escape: clearInput(inputRef)})}/>
 * @param ref
 */
export function clearInput(ref: RefObject<{ value: string }>) {
  return () => {
    if (ref && ref.current) {
      ref.current.value = "";
    }
  };
}

/**
 * Example: <form onSubmit={disableFormSubmit}>
 * @param e
 */
export const disableFormSubmit: FormEventHandler<HTMLFormElement> = (
  e: FormEvent
) => {
  e.preventDefault();
  return false;
};
